import { CreateEditorMode } from '../EditorModeInfo';

export const DesignMode = CreateEditorMode(
    'design',
    'Design Mode',
    'Use design mode to design new boards or modify existing templates to suite your needs.',
    'deqo://icons/meeting/design-mode'
);
